import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Infinite from 'react-infinite';

const PAGE_SIZE = 20;

export default class extends React.Component {
  static propTypes = {
    listItemProps: ImmutablePropTypes.listOf(PropTypes.object).isRequired,
    apiCall: PropTypes.func,
    mapListItemPropsToApiCallParams: PropTypes.func,
    listItemComponent: PropTypes.func.isRequired,
    className: PropTypes.string,
    elementHeight: PropTypes.number,
    infiniteLoadBeginEdgeOffset: PropTypes.number,
  };

  state = {
    childElements: [],
  };

  /**
   *
   * @param {number} startIndex
   * @param {number} endIndex
   * @returns {Array}
   */
  renderListItems = (startIndex, endIndex) => {
    const propsToRender = this.props.listItemProps.slice(startIndex, endIndex).toJS();
    const ListItemComponent = this.props.listItemComponent;

    if (this.props.apiCall) {
      this.props.apiCall(this.props.mapListItemPropsToApiCallParams(propsToRender));
    }

    return propsToRender.map((props, index) => (
      <ListItemComponent {...props} key={`${startIndex}-${endIndex}-${index}`} />
    ));
  };

  onInfiniteLoad = () => {
    const finalIndex = this.props.listItemProps.size;
    const startIndex = this.state.childElements.length;

    // No more items to render
    if (startIndex >= finalIndex) {
      return;
    }

    const verifyEndIndex = startIndex + PAGE_SIZE;
    const endIndex = verifyEndIndex > finalIndex ? finalIndex : verifyEndIndex;

    const newChildElements = this.renderListItems(startIndex, endIndex);

    this.setState({
      childElements: this.state.childElements.concat(newChildElements),
    });
  };

  render() {
    return (
      <Infinite
        className={this.props.className}
        elementHeight={this.props.elementHeight}
        infiniteLoadBeginEdgeOffset={this.props.infiniteLoadBeginEdgeOffset}
        onInfiniteLoad={this.onInfiniteLoad}
        useWindowAsScrollContainer={true}
        preloadBatchSize={Infinite.containerHeightScaleFactor(2)}
      >
        {this.state.childElements}
      </Infinite>
    );
  }
}
